import React, { useState } from 'react'
import HistoryTextBox from './HistoryTextBox'
import HistoryViewButton from './HistoryViewButton'
import allImgPaths from 'assets/images'
import HistoryFileUpload from './HistoryFileUpload';
import { format } from 'date-fns';
import HistoryThemeBox from './HistoryThemeBox';
import { isArray } from 'lodash';

interface SelectionProps {
    activityIcon?: any;
    data: any;
    period: any
}

const Selection = ({ activityIcon, data, period }: SelectionProps) => {
    const handleImageError = (e: any) => {
        e.target.src = allImgPaths.defaultProfile
    }

    const [currentTask, setCurrentTask] = useState<any>(data?.task?.title)
    const [isView, setIsView] = useState(true)
    const [showMore, setShowMore] = useState(false)

    return (
        <>
            <div className="px-3 pt-3 pb-4 mb-5 last:pb-3 last:mb-0 border-b border-[#F1F1F1] last:border-b-transparent">
                <div className="flex gap-x-4 mb-4">
                    <div className="relative w-10">
                        <img className="min-w-10 h-10 rounded-full" onError={handleImageError} src={data?.user?.profile_image || allImgPaths.defaultProfile} alt="" />
                        <img
                            className="absolute top-7 -right-1 w-5 h-5 rounded-full"
                            src={allImgPaths.historySelected}
                            alt=""
                        />
                    </div>

                    <div className="leading-none">
                        <div className="font-interMedium text-base text-[#4F4D55] pb-0.5">
                            <span className="font-interMedium text-base text-[#0A090B]">
                                {data?.action_data?.action_user?.name || 'A user'}
                            </span>

                            {
                                data?.action_data?.fields == 'addTask' &&
                                <>
                                    <span> added </span>
                                    {
                                        currentTask?.toLowerCase() === 'venue' &&
                                        <span>venues</span>
                                    }
                                    {
                                        currentTask?.toLowerCase() === 'event themes' &&
                                        <span>event themes</span>
                                    }
                                    {
                                        (currentTask?.toLowerCase() === 'décor themes' || currentTask?.toLowerCase() === 'decor themes') &&
                                        <span>decor themes</span>
                                    }
                                    {
                                        currentTask?.toLowerCase() === 'venue styles' &&
                                        <span>venue styles</span>
                                    }
                                    {
                                        !data?.action_data?.new_value?.length &&

                                        <div className='border border-[#D8D8D8] px-2 py-2 rounded-[10px] bg-[#fff] w-[280px] flex-shrink-0 hover:shadow-xl'>
                                            <div className='relative'>
                                                <div className='h-[190px] rounded-[10px] mb-2.5'>
                                                    <img
                                                        className={`rounded-[10px] w-full h-full object-cover mb-2`}
                                                        src={data?.imageUrl ? data.imageUrl : allImgPaths.dummyImg}
                                                        alt=''
                                                    />
                                                </div>
                                                <h5 className='text-[#101828] font-interSemiBold text-lg px-0.5 pb-2'>
                                                    {data?.action_data?.new_value?.title}
                                                </h5>
                                                <div>
                                                    {data?.action_data?.new_value?.imageDescription || data?.action_data?.new_value?.description}
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </>
                            }
                            {
                                data?.action_data?.fields == 'isPinned' &&
                                <>
                                    <span>
                                        {
                                            data?.action_data?.action_text == 'task-unpinned' ? ' unpinned a ' : ' pinned a '
                                        }
                                    </span>
                                    {
                                        currentTask?.toLowerCase() == 'draft invitations' &&
                                        <span >draft invitation content </span>
                                    }
                                    {
                                        currentTask?.toLowerCase() === 'event themes' &&
                                        <span>event theme</span>
                                    }
                                    {
                                        (currentTask?.toLowerCase() === 'décor themes' || currentTask?.toLowerCase() === 'decor themes') &&
                                        <span>decor theme</span>
                                    }
                                    {
                                        currentTask?.toLowerCase() === 'venue styles' &&
                                        <span>venue styles</span>
                                    }
                                    {
                                        currentTask?.toLowerCase() === 'draft event program' &&
                                        <span>draft event program</span>
                                    }
                                    {
                                        currentTask?.toLowerCase() === 'venue' &&
                                        <span>venue</span>
                                    }
                                    {
                                        currentTask?.toLowerCase() === 'create attendee list' &&
                                        <span>attendee list</span>
                                    }
                                    {
                                        (data?.action_data?.item && data?.action_data?.item != 'isEmailContent' && data?.action_data?.item != 'isRichTextContent' && data?.action_data?.item != 'isFileUpload') &&
                                        <span className="font-interMedium text-base text-[#1751D0]"> {data?.action_data?.item}</span>
                                    }
                                    {
                                        (data?.action_data?.item && (data?.action_data?.item == 'isEmailContent' || data?.action_data?.item == 'isRichTextContent')) &&
                                        <>
                                            <span> for </span>
                                            <span className="font-interMedium text-base text-[#1751D0]">{data?.card?.title}</span>
                                            <span> card </span>
                                        </>
                                    }
                                </>
                            }
                            {
                                data?.action_data?.fields == 'isFavorite' &&
                                <>
                                    <span> marked a </span>
                                    {
                                        currentTask?.toLowerCase() == 'draft invitations' &&
                                        <span>draft invitation content </span>
                                    }
                                    {
                                        currentTask?.toLowerCase() === 'event themes' &&
                                        <span>event theme</span>
                                    }
                                    {
                                        (currentTask?.toLowerCase() === 'décor themes' || currentTask?.toLowerCase() === 'decor themes') &&
                                        <span>decor theme</span>
                                    }
                                    {
                                        currentTask?.toLowerCase() === 'venue styles' &&
                                        <span>decor theme</span>
                                    }
                                    {
                                        currentTask?.toLowerCase() === 'venue' &&
                                        <span>venue</span>
                                    }
                                    {
                                        (data?.action_data?.item && data?.action_data?.item != 'isEmailContent' && data?.action_data?.item != 'isRichTextContent') &&
                                        <span className="font-interMedium text-base text-[#1751D0]"> {data?.action_data?.item}</span>
                                    }
                                    {
                                        (data?.action_data?.item && (data?.action_data?.item == 'isEmailContent' || data?.action_data?.item == 'isRichTextContent')) &&
                                        <>
                                            <span className="font-interMedium text-base text-[#1751D0]">{data?.card?.title}</span>
                                            <span> draft </span>
                                        </>
                                    }
                                    <span> as </span>
                                    <span className="font-interMedium text-base text-[#1751D0]">
                                        {
                                            data?.action_data?.new_value === true ? ' favorite ' : ' unfavorite '
                                        }
                                    </span>
                                </>
                            }
                            {
                                data?.action_data?.fields == 'tagsUpdated' &&
                                <>
                                    <span> updated a </span>
                                    {
                                        (currentTask?.toLowerCase() === 'décor themes' || currentTask?.toLowerCase() === 'decor themes') &&
                                        <span>decor theme</span>
                                    }
                                    {
                                        currentTask?.toLowerCase() === 'venue styles' &&
                                        <span>decor theme</span>
                                    }
                                    {
                                        <span className="font-interMedium text-base text-[#1751D0]"> {data?.action_data?.item}</span>
                                    }
                                    {
                                        <>
                                            <span> tags from </span>
                                            <span className="font-interMedium text-base text-[#1751D0]">
                                                {data.action_data.old_value.join(', ')}
                                            </span>
                                            <span> to </span>
                                            <span className="font-interMedium text-base text-[#1751D0]">
                                                {data.action_data.new_value.join(', ')}
                                            </span>
                                        </>
                                    }
                                </>
                            }
                            {
                                data?.action_data?.fields == 'isDelete' &&
                                <>
                                    <span> deleted a </span>
                                    {
                                        currentTask?.toLowerCase() == 'draft invitations' &&
                                        <span className="font-interMedium text-base text-[#0A090B]">draft invitation content </span>
                                    }
                                    {
                                        currentTask?.toLowerCase() == 'draft event program' &&
                                        <span className="font-interMedium text-base text-[#0A090B]">draft event program </span>
                                    }
                                    {
                                        currentTask?.toLowerCase() === 'event themes' &&
                                        <span className="font-interMedium text-base text-[#0A090B]">event theme</span>
                                    }
                                    {
                                        (currentTask?.toLowerCase() === 'décor themes' || currentTask?.toLowerCase() === 'decor themes') &&
                                        <span className="font-interMedium text-base text-[#0A090B]">decor theme</span>
                                    }
                                    {
                                        currentTask?.toLowerCase() === 'venue styles' &&
                                        <span className="font-interMedium text-base text-[#0A090B]">decor theme</span>
                                    }
                                    {
                                        currentTask?.toLowerCase() === 'venue' &&
                                        <>
                                            <span className="font-interMedium text-base text-[#0A090B]">venue</span>
                                            {
                                                data?.action_data?.delete_data?.isRFP &&
                                                <span className="font-interMedium text-base text-[#0A090B]"> RFP</span>
                                            }
                                        </>
                                    }
                                    {
                                        (data?.action_data?.item && data?.action_data?.item != 'isEmailContent' && data?.action_data?.item != 'isRichTextContent') &&
                                        <span className="font-interMedium text-base text-[#1751D0]"> {data?.action_data?.item}</span>
                                    }
                                    {
                                        (data?.action_data?.item && (data?.action_data?.item == 'isEmailContent' || data?.action_data?.item == 'isRichTextContent')) &&
                                        <>
                                            <span> draft </span>
                                        </>
                                    }
                                </>
                            }
                            {
                                data?.action_data?.fields == 'budget-allocation' &&
                                <>
                                    {
                                        data?.action_data?.action_text == 'budgetCreated' &&
                                        <span> created a budget allocation</span>
                                    }
                                    {
                                        data?.action_data?.action_text == 'categoryAdded' &&
                                        <>
                                            <span> added budget category </span>
                                            <span className="font-interMedium text-base text-[#1751D0]">{data.action_data.new_value.join(', ')} </span>

                                        </>
                                    }
                                    {
                                        data?.action_data?.action_text == 'categoryRemoved' &&
                                        <>
                                            <span> removed budget category </span>
                                            <span className="font-interMedium text-base text-[#1751D0]">{data.action_data.new_value.join(', ')}</span>

                                        </>
                                    }
                                    {
                                        data?.action_data?.action_text == 'budgetUpdated' &&
                                        <>
                                            <span> updated budget category </span>
                                            {/* <span className="font-interMedium text-base text-[#1751D0]">{data.action_data.new_value.join(', ')}</span> */}
                                            {
                                                data?.action_data?.new_value?.map((nv: any, index: number) => (
                                                    <React.Fragment key={index}>
                                                        <span className="font-interMedium text-base text-[#1751D0]"> {nv?.category} </span>
                                                        <span> value to </span>
                                                        <span className="font-interMedium text-base text-[#1751D0]">{nv?.originalValue}</span>
                                                    </React.Fragment>
                                                ))
                                            }

                                        </>
                                    }
                                </>
                            }
                            {
                                data?.action_data?.fields == 'add-logistics' &&
                                <>
                                    {
                                        data?.action_data?.action_text == 'add-logistics' &&
                                        <span> created a logistics</span>
                                    }
                                    {
                                        data?.action_data?.action_text == 'edit-logistics' &&
                                        <span> edited a logistics</span>
                                    }
                                </>
                            }

                        </div>
                        {
                            // !isArray(data?.action_data?.new_value) &&
                            <div className="leading-none flex items-center gap-x-2.5">
                                {
                                    (period == 'Today' || period == 'Yesterday') &&
                                    <span className="text-xs text-[#7F7D83]">
                                        {format(data?.createdAt, 'hh:mm a')}
                                    </span>
                                }
                                {
                                    period != 'Today' && period != 'Yesterday' &&
                                    <span className="text-xs text-[#7F7D83]">
                                        {format(data?.createdAt, 'EEEE, MMM dd yyyy, hh:mm a')}
                                    </span>
                                }
                                <span className="w-1 h-1 bg-[#7F7D83] rounded-full block"></span>
                                <span className="text-xs text-[#7F7D83]">
                                    {/* Guest Management / Special guests and speakers */}
                                    {data?.block?.title} / {data?.card?.title}
                                </span>
                            </div>
                        }
                    </div>
                </div>
                {
                    data?.action_data?.fields == 'addTask' && isArray(data?.action_data?.new_value) &&
                    <>
                        <HistoryThemeBox data={data?.action_data?.new_value || []} />
                        <div className="ml-14">
                            <HistoryViewButton />
                        </div>
                    </>
                }
                {
                    (data?.action_data?.fields == 'isDelete' && data?.action_data?.delete_data && data?.action_data?.item != 'isRichTextContent' && data?.action_data?.item != 'isEmailContent' && !data?.action_data?.delete_data?.isRFP && !data?.action_data?.delete_data?.isRichTextContent && !data?.action_data?.delete_data?.isEmailContent) &&
                    <>
                        <HistoryThemeBox data={[data?.action_data?.delete_data] || []} />
                        <div className="ml-14">
                            <HistoryViewButton />
                        </div>
                    </>
                }
                {
                    (data?.action_data?.fields == 'isDelete' && data?.action_data?.delete_data && data?.action_data?.delete_data?.isRichTextContent) &&
                    <>
                        <HistoryTextBox
                            title={data?.action_data?.delete_data?.title}
                            html={data?.action_data?.delete_data?.content}
                            type={'isRichTextContent'}
                            showMore={showMore}
                        />
                        <div className="ml-14">
                            {
                                isView &&
                                <button
                                    className="py-1.5 px-3 text-[#fff] text-sm bg-[#1751D0] rounded-md font-interMedium"
                                    onClick={() => { setIsView(false); setShowMore(true) }}
                                >
                                    View
                                </button>
                            }
                            {
                                !isView &&
                                <button
                                    className="py-1.5 px-3 text-[#fff] text-sm bg-[#1751D0] rounded-md font-interMedium"
                                    onClick={() => { setIsView(true); setShowMore(false) }}
                                >Hide
                                </button>
                            }
                        </div>
                    </>
                }
                {
                    (data?.action_data?.fields == 'isDelete' && data?.action_data?.delete_data && data?.action_data?.delete_data?.isEmailContent) &&
                    <>
                        <HistoryTextBox
                            title={data?.action_data?.delete_data?.title}
                            html={data?.action_data?.delete_data?.content}
                            showMore={showMore}
                            type={'isEmailContent'}
                        />
                        <div className="ml-14">
                            {
                                isView &&
                                <button
                                    className="py-1.5 px-3 text-[#fff] text-sm bg-[#1751D0] rounded-md font-interMedium"
                                    onClick={() => { setIsView(false); setShowMore(true) }}
                                >
                                    View
                                </button>
                            }
                            {
                                !isView &&
                                <button
                                    className="py-1.5 px-3 text-[#fff] text-sm bg-[#1751D0] rounded-md font-interMedium"
                                    onClick={() => { setIsView(true); setShowMore(false) }}
                                >Hide
                                </button>
                            }
                        </div>
                    </>
                }
                {
                    (data?.action_data?.fields == 'isDelete' && data?.action_data?.delete_data && data?.action_data?.delete_data?.isRFP) &&
                    <>
                        <HistoryTextBox
                            title={data?.action_data?.delete_data?.title}
                            html={data?.action_data?.delete_data?.content}
                            type={'isRFP'}
                            showMore={showMore}
                        />
                        <div className="ml-14">
                            {
                                isView &&
                                <button
                                    className="py-1.5 px-3 text-[#fff] text-sm bg-[#1751D0] rounded-md font-interMedium"
                                    onClick={() => { setIsView(false); setShowMore(true) }}
                                >
                                    View
                                </button>
                            }
                            {
                                !isView &&
                                <button
                                    className="py-1.5 px-3 text-[#fff] text-sm bg-[#1751D0] rounded-md font-interMedium"
                                    onClick={() => { setIsView(true); setShowMore(false) }}
                                >Hide
                                </button>
                            }
                        </div>
                    </>
                }

            </div>
        </>
    )
}

export default Selection